export default {
  LOWEST: 'lowest',
  AAA: 'aaa',
  GOVERNMENT: 'government',
  SENIOR: 'senior',
  PAC: 'pac',
  ECERT: 'eCert',
  CORPORATE_ACCOUNT: 'corporateAccount',
  TRAVEL_AGENCY: 'travelAgency',
  AARP_MEMBER: 'aarpMember'
}
